import { useParams } from "react-router-dom";

import { useGetAlarmByIdQuery } from '../../../services/alarm'
import { LoadingView } from '../../../components'
import { AlarmDetailsView } from './'


const AlarmDetailsViewContainer = () => {
    const prms = useParams();
    const alarmId = prms.alarmId ?? '';
    const resourceGroupId = prms.resourceGroupId ?? '';
    const { data: alarm, isLoading, isSuccess, isError, error } = useGetAlarmByIdQuery({alarmId: alarmId, resourceGroupId: resourceGroupId});

    return (
        <LoadingView isLoading={isLoading} isSucess={isSuccess} error={error}>
            {alarm && <AlarmDetailsView {...alarm}></AlarmDetailsView>}
        </LoadingView>
    )
}

export default AlarmDetailsViewContainer;


